import {transformDigitToFinancial} from '../../../../utils/transformDigitToFinancial'

export const transformPrice = (price: number | string) => transformDigitToFinancial(price, { withRuble: true, withFloat: true });
